/**
 * @file RedirectSkeleton.jsx
 * @description Skeleton loader for Redirect Page (shadcn/ui version)
 * @version 0.1.0
 * Created at: 29/10/2025
 */

import { ImeldLogo } from '@/assets';
import { Image, Skeleton } from '@/components';

const RedirectSkeleton = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-svh bg-background">
      {/* Logo Section */}
      <div className="mb-8">
        <Image
          src={ImeldLogo}
          alt="Imeld Logo"
          className="w-40 h-12 object-contain opacity-50"
        />
      </div>

      {/* Message Placeholder */}
      <div className="space-y-3 w-[80%] max-w-sm text-center">
        <Skeleton className="h-6 w-3/4 mx-auto" />
        <Skeleton className="h-4 w-2/3 mx-auto" />
      </div>

      {/* Progress/Loader Section */}
      <div className="mt-8 w-[60%] max-w-xs">
        <Skeleton className="h-2 w-full rounded-full" />
      </div>
    </div>
  );
};

export default RedirectSkeleton;
